import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { ProcurementItemCategory } from '../../models/item-master';

@Injectable({
  providedIn: 'root',
})
export class ProcurementItemCategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/procurement-item-category';

  getAllItemsCategories(): Observable<ApiResponse<ProcurementItemCategory[]>> {
    return this.httpClient.get<ApiResponse<ProcurementItemCategory[]>>(`${this.baseUrl}/all`);
  }
}
